var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"no-menu":"","folded":false,"no-title":"","hfull":""}},[_c('user-form',{attrs:{"user-id":_vm.$uloc.auth.session.user.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }